var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoSquareWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 189,
    viewBox: "0 0 189 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9971 189.006H62.9924V125.998H41.9971V189.006Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M167.981 189.006H188.976V84.0082H167.981V189.006Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 189.006H20.9953V63.0067H0V189.006Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9863 188.896H104.982V41.9026H83.9863V188.896Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9971 105.003H62.9924V0.00667991H41.9971V105.003Z",
    fill: "#FAB80A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M125.991 189.006H146.986V105.003H125.991V189.006Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M125.991 84.0081H146.986V0.00666598H125.991V84.0081Z",
    fill: "#FAB80A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 42.004H20.9953V0.00666958H0V42.004Z",
    fill: "#FAB80A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M167.981 1.3928e-05V63.0067H188.976V1.3928e-05H167.981Z",
    fill: "#FAB80A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9863 21.0013H104.982V0.00668257H83.9863V21.0013Z",
    fill: "#FAB80A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSquareWhite);
export default __webpack_public_path__ + "static/media/LogoSquareWhite.1c49675fe24572e49bef2dfc1b9c84e9.svg";
export { ForwardRef as ReactComponent };